<template>
    <div>
        <div class="home-ban">
            <div class="home-live">
                <div class="live-video">
                    <video-player class="video-player vjs-custom-skin" v-if="videoOptions.sources[0].src"
                        ref="videoPlayer" :options="videoOptions" @play="onPlay" @pause="onPause"></video-player>
                </div>
                <div class="live-list">
                    <div :class="item.id == liveId ? 'actlist-box list-box' : 'list-box'" v-for="item in homeList"
                        :key="item.id" @click="changeUrl(item)">
                        <img :src="item.picUrl" alt="" />
                        <div class="box-text">
                            <p class="box-title">{{ item.title }}</p>
                            <p class="box-info">{{ item.content }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="home-cont">
            <div class="cont-div">
                <div class="cont-top">
                    <div class="cont-box">
                        <div class="box-title">
                            <img src="../assets/tuijian.png" alt="" />
                            <span>为你推荐</span>
                        </div>
                        <div>
                            <el-carousel trigger="click" class="carousel-style">
                                <el-carousel-item v-for="item in recommList" :key="item.id">
                                    <div class="carousel-img" @click="gotoPage(item.linkUrl)">
                                        <img :src="item.picUrl" alt="" />
                                    </div>
                                    <p class="carousel-title">
                                        {{ item.title }}
                                    </p>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                    <div class="cont-box">
                        <div class="box-title new-title">
                            <div class="box-titles">
                                <img src="../assets/zuixin.png" alt="" />
                                <span>最新资讯</span>
                            </div>
                            <!-- <div class="title-more">更多></div> -->
                        </div>
                        <div class="zixun-list">
                            <div class="line"></div>
                            <div class="zuixin-info">
                                <div class="info-box" v-for="item in messageList" :key="item.id"
                                    @click="gotoDetail(item)">
                                    <p class="info-title">
                                        {{ item.title }}
                                    </p>
                                    <p class="info-time">{{ item.addtime }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cont-box">
                        <div class="box-title">
                            <img src="../assets/hudong.png" alt="" />
                            <span>互动预告</span>
                        </div>
                        <div class="hudong-list">
                            <div class="line"></div>
                            <div class="hudong-box">
                                <div class="hudong-info">
                                    <p class="info-time">25日22:10</p>
                                    <p class="info-title">
                                        芊芊互动空间惊喜不断
                                    </p>
                                </div>
                                <!-- <div class="yuyue-box">
                                    <img class="yuyue-img" src="../assets/demo.png" alt="" />
                                    <div class="yuyue-but">
                                        <div>
                                            <img src="../assets/yuyue.png" alt="" />
                                            <p>预约</p>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="hudong-info">
                                    <p class="info-time">25日22:10</p>
                                    <p class="info-title">
                                        芊芊互动空间惊喜不断
                                    </p>
                                </div>
                                <div class="hudong-info">
                                    <p class="info-time">25日22:10</p>
                                    <p class="info-title">
                                        芊芊互动空间惊喜不断
                                    </p>
                                </div>
                                <div class="hudong-info">
                                    <p class="info-time">25日22:10</p>
                                    <p class="info-title">
                                        芊芊互动空间惊喜不断
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cont-bot">
                    <div class="cont-box">
                        <div class="box-title new-title">
                            <div class="box-titles">
                                <img src="../assets/new-hu.png" alt="" />
                                <span>互动日常</span>
                            </div>
                            <div class="title-more" @click="gotoActive">
                                更多>
                            </div>
                        </div>
                        <div class="bot-list">
                            <div class="line"></div>
                            <div class="list-div">
                                <div class="list-box" v-for="item in dailyList" :key="item.id"
                                    @click="gotoAction(item.id)">
                                    <!-- @click="changeDay(item.videoUrl)" -->
                                    <div class="box-img">
                                        <img class="img-bg" :src="item.picUrl" alt="" />
                                        <div class="img-time">
                                            <img src="../assets/hu-time.png" alt="" />
                                            <span>{{ item.playTime }}</span>
                                        </div>
                                    </div>
                                    <div class="list-title">
                                        <div class="title-info">
                                            {{ item.title }}
                                        </div>
                                        <div class="title-text">
                                            <div class="text-name">
                                                <img src="../assets/hu-user.png" alt="" />
                                                <span>{{ item.userName }}</span>
                                            </div>
                                            <div class="text-name">
                                                <img src="../assets/hu-video.png" alt="" />
                                                <span>{{
                                                    item.num > 10000
                                                        ? Math.floor(
                                                            item.num / 10000
                                                        ) + "万"
                                                        : item.num
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="home-down">
            <div class="down-left">
                <p class="left-one">入驻互动空间 开始互动<span>之旅</span></p>
                <p class="left-two">2025 携手共赴财富之巅</p>
                <div class="left-three">
                    <img src="../assets/down-phone.png" alt="" />
                    <div class="three-text">
                        <p class="text-one">智能手机</p>
                        <p class="text-two">使用IOS 安卓智能手机</p>
                    </div>
                </div>
                <div class="left-four">
                    <img src="../assets/icon_logo.png" alt="" />
                    <div class="three-text">
                        <p class="text-one"></p>
                        <p class="text-two">参与美好生活</p>
                    </div>
                </div>
                <div class="left-five">
                    <!-- @click="changeSettl" -->
                    <div class="five-but" @click="changeSettl">个人入驻</div>
                    <div class="five-but" @click="changeSettl">MCN机构入驻</div>
                </div>
                <img class="down-bg" src="../assets/down-bg.png" alt="" />
            </div>
        </div>
        <div class="home-right">
            <div class="right-box">
                <el-popover placement="left" trigger="hover" popper-class="my-custom-popover">
                    <div class="popover-box">
                        <!-- <img src="https://static.cd.zhangkongyl.cn:901/headimg/20250305152722_1588f091-5ed4-475b-a8ad-abf72b33980c.png"
                            alt=""> -->
                        <img :src="configList.config?.downloadCode" alt="">
                        <p>扫码下载游戏</p>
                    </div>
                    <div slot="reference">
                        <img src="../assets/icon-down.png" alt="" />
                        <p>下载</p>
                    </div>
                </el-popover>
            </div>
            <div class="right-box">
                <el-popover placement="left" trigger="hover" popper-class="my-custom-popover">
                    <div class="popover-box">
                        <!-- <img src="https://static.cd.zhangkongyl.cn:901/headimg/20250305152621_067769a1-f2c7-4e26-a759-6ccfe6164402.png"
                            alt=""> -->
                        <img :src="configList.config?.contactCode" alt="">
                        <p>扫码入驻</p>
                    </div>
                    <div slot="reference">
                        <img src="../assets/icon-ruzhu.png" alt="" />
                        <p>入驻</p>
                    </div>
                </el-popover>
            </div>
            <div class="right-box">
                <el-popover placement="left" trigger="hover" popper-class="my-custom-popover">
                    <div class="popover-box">
                        <!-- <img src="https://static.cd.zhangkongyl.cn:901/headimg/20250305152519_7f445773-4bc3-4abb-86f1-4765dd873b10.png"
                            alt=""> -->
                        <img :src="configList.config?.officialCode" alt="">
                        <p>扫码加微信</p>
                    </div>
                    <div slot="reference">
                        <img src="../assets/icon-weixin.png" alt="" />
                        <p>微信</p>
                    </div>
                </el-popover>
            </div>
            <div class="right-box new-rightBox">
                <el-popover placement="left" trigger="hover" popper-class="my-custom-popover">
                    <div class="popover-box">
                        <!-- <img src="https://static.cd.zhangkongyl.cn:901/headimg/20250305152554_8e732357-6c4c-473b-888c-1907726fe700.png"
                            alt=""> -->
                        <img :src="configList.config?.businessCode" alt="">
                        <p>扫码联系客服</p>
                    </div>
                    <div slot="reference">
                        <img src="../assets/icon-kefu.png" alt="" />
                        <p>客服</p>
                    </div>
                </el-popover>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" width="20%" class="dialog-style">
            <!-- :close-on-click-modal="false" -->
            <div class="dialog-sett">
                <img :src="configList.config?.contactCode" alt="">
            </div>
            <p>请微信扫码添加商务经理进行咨询</p>
        </el-dialog>
    </div>
</template>

<script>
import {
    homeVideoApi,
    homeRecommApi,
    homeMessageApi,
    homeDailyApi,
    configDataApi
} from "../api/api.js";
export default {
    name: "Home",
    data() {
        return {
            videoOptions: {
                // video.js的配置选项
                controls: true,
                autoplay: true,
                muted: true,
                loop: true,
                width: "100%", // 可以设置为具体的像素值或百分比
                // height: "100%", // 同上
                sources: [
                    {
                        src: "", // 替换为你的视频源
                        type: "video/mp4",
                    },
                ],
                controlBar: {
                    volumeControl: true,
                    remainingTimeDisplay: false,
                },
                notSupportedMessage: "此视频暂无法播放，请稍后再试",
            },
            homeList: [],
            recommList: [],
            messageList: [],
            dailyList: [],
            dialogVisible: false,
            liveId: '',
            configList: {}
        };
    },
    components: {},
    mounted() {
        this.homeVideo();
        this.homeRecomm();
        this.homeMessage();
        this.homeDaily();
        this.configData()
    },
    methods: {
        onPlay() {
            console.log("Video is playing");
        },
        onPause() {
            console.log("Video is paused");
        },
        async homeVideo() {
            const res = await homeVideoApi({
                pageindex: 1,
                pagesize: 4,
                cateType: 1,
            });
            this.homeList = res.data.data.records;
            this.liveId = res.data.data.records[0].id
            this.videoOptions.sources[0].src =
                res.data.data.records[0].videoUrl;
            // console.log(res, "homeVideoApi");
        },
        async configData() {
            const res = await configDataApi()
            this.configList = res.data.data
        },
        changeUrl(val) {
            this.liveId = val.id
            this.videoOptions.sources[0].src = val.videoUrl;
        },
        async homeRecomm() {
            const res = await homeRecommApi({
                pageindex: 1,
                pagesize: 4,
                cateType: 2,
            });
            this.recommList = res.data.data.records;
        },
        gotoPage(url) {
            const windowName = "newWindow"; // 新窗口的名称
            const windowFeatures =
                "width=900,height=600,resizable=yes,scrollbars=yes"; // 新窗口的特性

            // 使用 window.open 打开新窗口
            window.open(url, windowName, windowFeatures);
        },
        async homeMessage() {
            const res = await homeMessageApi({
                pageindex: 1,
                pagesize: 6,
                cateType: 3,
            });
            this.messageList = res.data.data.records;
        },
        async homeDaily() {
            const res = await homeDailyApi();
            this.dailyList = res.data.data.slice(0, 5);
        },
        gotoAction(id) {
            this.$router.push({
                path: "/interactive",
                query: {
                    id,
                },
            });
        },
        gotoActive() {
            this.$router.push({
                path: "/interactive",
            });
        },
        gotoDetail(item) {
            this.$router.push({
                path: "/helpDetail",
                query: {
                    detail: JSON.stringify(item),
                }
            });
        },
        changeSettl() {
            this.dialogVisible = true;
        },
    },
};
</script>
<style lang="scss" scoped>
.home-ban {
    width: 100vw;
    height: 946px;
    background-image: url("../assets/home-bg.png");
    background-position: center;
    background-size: cover;

    .home-live {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        .live-video {
            width: 55%;
            height: 70%;

            .video-player {
                width: 100%;
                height: 100%;
            }
        }

        .live-list {
            margin-left: 20px;

            .list-box {
                width: 274px;
                height: 150px;
                position: relative;
                margin-bottom: 5px;

                img {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                }

                .box-text {
                    position: relative;
                    z-index: 1;
                    padding-top: 30%;
                    padding-left: 15px;

                    .box-title {
                        font-size: 22px;
                        color: #ffffff;
                    }

                    .box-info {
                        font-size: 12px;
                        padding-top: 5px;
                        color: #c3c3c3;
                    }
                }
            }

            .actlist-box {
                border: 1px solid #ff9503;
            }
        }
    }
}

.home-cont {
    width: 100vw;
    height: 1188px;
    background-image: url("../assets/home-center.png");
    background-position: center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;

    .cont-div {
        width: 67%;
        margin: 0 auto;

        .cont-top {
            display: flex;
            justify-content: space-between;

            .cont-box {
                .box-title {
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;

                    img {
                        width: 25px;
                        height: 25px;
                    }

                    span {
                        font-size: 18px;
                        color: #000000;
                        font-weight: bold;
                        padding-left: 10px;
                    }
                }

                .box-titles {
                    display: flex;
                    align-items: center;
                }

                .new-title {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                .title-more {
                    color: #747474;
                    font-size: 14px;
                    cursor: pointer;
                }

                .carousel-style {
                    width: 352px;
                    height: 334px;
                    position: relative;
                    cursor: pointer;

                    .carousel-img {
                        width: 100%;
                        height: 100%;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                .carousel-title {
                    position: absolute;
                    bottom: 5%;
                    left: 5%;
                    font-size: 14px;
                    color: #fff;
                }

                .zixun-list {
                    width: 610px;
                    height: 304px;
                    background: #242424;
                    padding-top: 30px;

                    .line {
                        width: 531px;
                        height: 1px;
                        background: #6d6d6d;
                        margin: 0 auto;
                    }

                    .zuixin-info {
                        padding: 0 40px;
                        padding-top: 20px;

                        .info-box {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            font-size: 14px;
                            padding: 10px 0;
                            cursor: pointer;

                            .info-title {
                                color: #fff;
                                white-space: nowrap;
                                /* 不换行 */
                                overflow: hidden;
                                /* 隐藏超出的内容 */
                                text-overflow: ellipsis;
                                /* 用省略号表示被隐藏的部分 */
                                max-width: 50%;
                                /* 设置最大宽度以限制文本的显示长度 */
                            }

                            .info-time {
                                color: #7c7c7c;
                            }
                        }
                    }
                }

                .hudong-list {
                    width: 302px;
                    height: 304px;
                    background: #242424;
                    padding-top: 30px;

                    .line {
                        width: 240px;
                        height: 1px;
                        background: #6d6d6d;
                        margin: 0 auto;
                    }

                    .hudong-box {
                        padding: 0 30px;
                        padding-top: 20px;

                        .hudong-info {
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 12px 0;

                            .info-time {
                                color: #ff9000;
                            }

                            .info-title {
                                color: #fff;
                                white-space: nowrap;
                                /* 不换行 */
                                overflow: hidden;
                                /* 隐藏超出的内容 */
                                text-overflow: ellipsis;
                                /* 用省略号表示被隐藏的部分 */
                                max-width: 60%;
                                /* 设置最大宽度以限制文本的显示长度 */
                            }
                        }

                        .yuyue-box {
                            width: 236px;
                            height: 69px;
                            display: flex;
                            border-radius: 5px;

                            .yuyue-img {
                                width: 80%;
                            }

                            .yuyue-but {
                                width: 20%;
                                background: #ff9503;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                text-align: center;

                                P {
                                    font-size: 10px;
                                    color: #000;
                                }
                            }
                        }
                    }
                }
            }
        }

        .cont-bot {
            margin-top: 100px;

            .cont-box {
                .box-titles {
                    display: flex;
                    align-items: center;
                    margin-bottom: 15px;

                    img {
                        width: 25px;
                        height: 25px;
                    }

                    span {
                        font-size: 18px;
                        color: #000000;
                        font-weight: bold;
                        padding-left: 10px;
                    }
                }

                .new-title {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                .title-more {
                    color: #747474;
                    font-size: 14px;
                    cursor: pointer;
                }
            }

            .bot-list {
                width: 100%;
                height: 400px;
                background: #242424;
                padding-top: 50px;

                .line {
                    width: 90%;
                    height: 1px;
                    background: #6d6d6d;
                    margin: 0 auto;
                }

                .list-div {
                    width: 90%;
                    margin: 0 auto;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    padding-top: 30px;

                    .list-box {
                        width: 185px;
                        margin: 0 25px;

                        .box-img {
                            width: 100%;
                            height: 250px;
                            position: relative;

                            .img-bg {
                                width: 100%;
                                height: 100%;
                                border-radius: 5px;
                            }

                            .img-time {
                                position: absolute;
                                bottom: 2%;
                                right: 7%;
                                display: flex;
                                align-items: center;

                                span {
                                    font-size: 14px;
                                    color: #fff;
                                }
                            }
                        }
                    }

                    .list-title {
                        .title-info {
                            color: #fff;
                            font-size: 16px;
                            padding: 10px 0;
                            white-space: nowrap;
                            /* 不换行 */
                            overflow: hidden;
                            /* 隐藏超出的内容 */
                            text-overflow: ellipsis;
                            /* 用省略号表示被隐藏的部分 */
                            max-width: 100%;
                            /* 设置最大宽度以限制文本的显示长度 */
                        }

                        .title-text {
                            font-size: 14px;
                            color: #838383;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;

                            .text-name {
                                display: flex;
                                align-items: center;

                                img {
                                    width: 12px;
                                    height: 12px;
                                    padding-right: 5px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.home-down {
    width: 100vw;
    height: 670px;
    background: #161616;
    position: relative;

    // overflow: hidden;
    .down-left {
        width: 50%;
        margin: 0 auto;
        padding-top: 150px;

        .left-one {
            font-size: 38px;
            font-weight: bold;
            color: #fff;

            span {
                color: #ff9000;
            }
        }

        .left-two {
            color: #fff;
            font-size: 24px;
            padding-top: 10px;
        }

        .left-three {
            display: flex;
            align-items: center;
            margin-top: 50px;

            img {
                width: 31px;
                height: 52px;
            }

            .three-text {
                padding-left: 20px;

                .text-one {
                    color: #fff;
                    font-size: 18px;
                    padding-bottom: 10%;
                }

                .text-two {
                    color: #858585;
                    font-size: 16px;
                }
            }
        }

        .left-four {
            display: flex;
            margin-top: 40px;

            img {
                width: 32px;
                height: 32px;
                border-radius: 5px;
            }

            .three-text {
                padding-left: 20px;

                .text-one {
                    color: #fff;
                    font-size: 18px;
                    padding-bottom: 10%;
                }

                .text-two {
                    color: #858585;
                    font-size: 16px;
                }
            }
        }

        .left-five {
            display: flex;
            font-size: 14px;
            color: #ff9000;
            margin-top: 80px;
            position: relative;
            z-index: 9999;

            .five-but {
                width: 140px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                border: 1px solid #ff9000;
                margin-right: 20px;
                cursor: pointer;
            }
        }
    }

    .down-bg {
        width: 864px;
        position: absolute;
        top: 10%;
        right: 15%;
    }
}

.home-right {
    background: #242424;
    width: 45px;
    height: 440px;
    position: fixed;
    right: 3%;
    top: 35%;
    padding: 0 20px;
    border-radius: 5px;

    .right-box {
        text-align: center;
        border-bottom: 1px solid #747474;
        padding: 23px 0;

        img {
            width: 37px;
        }

        p {
            color: #ffffff;
            font-size: 14px;
            padding-top: 5px;
        }
    }

    .new-rightBox {
        border: 0;
    }
}

.popover-box {
    width: 200px;
    // height: 200px;
    // background: #242424;
    color: #fff;
    text-align: center;

    img {
        width: 100%;
        height: 100%;
    }

    p {
        font-size: 16px;
        font-weight: bold;
        color: #000;
    }
}

::v-deep .el-carousel__arrow {
    display: none;
}

// .el-carousel__item:nth-child(2n) {
//     background-color: #99a9bf;
// }

// .el-carousel__item:nth-child(2n + 1) {
//     background-color: #d3dce6;
// }

/*指示器*/
::v-deep .el-carousel__indicators {
    left: unset;
    transform: unset;
    right: 2%;
}

/*指示器按钮*/
::v-deep .el-carousel__button {
    width: 10px;
    height: 10px;
    border: none;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.2);
}

/*指示器激活按钮*/
::v-deep .is-active .el-carousel__button {
    background: #f7c173;
}

::v-deep .el-carousel__container {
    height: 100%;
}

::v-deep .video-js {
    height: 100%;
}

.dialog-style {
    text-align: center;

    p {
        padding-top: 20px;
        font-weight: 16px;
        font-weight: bold;
    }
}

.dialog-sett {
    // background: pink;
    width: 140px;
    height: 140px;
    margin: 0 auto;

    img {
        width: 100%;
        height: 100%;
    }

    p {
        font-size: 16px;
        font-weight: bold;
        color: #000;
    }
}



/*播放按钮设置成宽高一致，圆形，居中*/
::v-deep .vjs-custom-skin>.video-js .vjs-big-play-button {
    outline: none;
    border: none;
    width: 66px;
    height: 66px !important;
    background-color: rgba(0, 0, 0, 0) !important;
}

::v-deep .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
    content: '';
    width: 66px;
    height: 66px;
    background: url('../assets/play.png') no-repeat;
    background-size: 100% 100%;
}

::v-deep .vjs-custom-skin>.video-js .vjs-play-progress:before {
    top: 0;
}
</style>
